@import frontend/shared/stylesheets/environment

$max-width: map-get($container-max-widths, xl)

// The Inertia app loads neither Bootstrap nor the Unpoly app's stylesheets, so the popup compiles the
// button styles it uses from the same sources.
$theme-colors: (primary: $primary)

.huge-notification--container
  position: fixed
  bottom: 0
  left: 0
  right: 0
  z-index: 11

  +not-in-tests
    transition: bottom ease-out 1s

  &:has(.-mod-minimized)
    bottom: -100vh
    +only-in-tests
      display: none

.huge-notification
  --border-radius: 20px
  --max-width: #{$max-width}

  margin-inline: auto
  width: min(var(--max-width), 100vw - 40px)
  box-shadow: 0 -2px 10px 2px color-mix(in srgb, $shadow-color 40%, transparent)
  border-radius: var(--border-radius) var(--border-radius) 0 0
  border-bottom-width: 0
  overflow: hidden

  @import bootstrap/scss/buttons
  @import frontend/shared/stylesheets/ext/bootstrap/btn

.huge-notification--close
  position: absolute
  top: 18px
  right: 20px
  color: $text-muted
  cursor: pointer
  z-index: 1

  background: none
  border: none
  padding: 0
  line-height: 0

// Fallback for the Bootstrap `.text-danger` class the banner markup uses.
//
// The banner is shared with the Inertia app, which has no Bootstrap. Wrapped in `:where()`, so it
// carries zero specificity and Bootstrap's own rule wins wherever it *is* loaded: the Unpoly app's
// appearance is unchanged.
:where(.text-danger)
  color: var(--color-error, #dc3545)
